<template>
    <div :class="['cz__image', {'cz__image-loading': this.loading === 'loading' }]">
        <div ref="imageview" :class="['cz__image-view', { 'cz__image-view--edit': editPlacement }]"></div>

        <image-editor :class="['cz__image-view-editor', { 'cz__image-view--edit': editPlacement }]" :controller="controller" :view="view"></image-editor>

        <div ref="imagesplitview" :class="['cz__image-view', 'cz__image-view--split', { 'cz__image-view--edit': editPlacement }]"></div>

        <div class="cz__image-editor-overlays">
            <portal-target name="editor-overlays" multiple>
            </portal-target>
        </div>

        <transition name="cz__fade">
            <button v-if="rangeView" class="cz__view-arrow cz__view-arrow-right" @mousedown="beginSpinFrame('next')" @mouseup="endSpinFrame()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"/></svg>
            </button>
        </transition>
        <transition name="cz__fade">
            <button v-if="rangeView" class="cz__view-arrow cz__view-arrow-left" @mousedown="beginSpinFrame('prev')" @mouseup="endSpinFrame()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"/></svg>
            </button>
        </transition>
    </div>
</template>

<style lang="less">
    .cz-render {
        position: absolute;

        left: 0;
        top: 0;

        width: 100%;
        height: 100%;
    }

    .cz__image {
        transition: opacity 0.2s linear;

        &.cz__image-loading {
            opacity: 0.2;
        }
    }

    .cz__image-view {
        position: absolute;

        left: 0;
        top: 0;

        width: 100%;
        height: 100%;
    }

    .cz__image-view.cz__image-view--split {
        transition: opacity 0.2s linear, visibility 0.2s linear;

        opacity: 0;
        visibility: hidden;

        pointer-events: none;

        &.cz__image-view--edit {
            opacity: 1;
            visibility: visible;
        }
    }

    .cz__image-view.cz__image-view--edit {
        pointer-events: none;
    }

    .cz__image-view-editor {
        transition: opacity 0.2s linear, visibility 0.2s linear;

        opacity: 0;

        visibility: hidden;

        pointer-events: none;

        &.cz__image-view--edit {
            opacity: 1;

            visibility: visible;

            pointer-events: auto;
        }
    }

    .cz__image-editor-overlays {
        position: absolute;

        left: 0;
        top: 0;

        width: 100%;
        height: 100%;

        pointer-events: none;
    }

    .cz__fade-enter-active, .cz__fade-leave-active {
        transition: opacity 0.2s linear;
    }

    .cz__fade-enter, .cz__fade-leave-to {
        opacity: 0;
    }

    .cz__view-arrow {
        position: absolute;

        width: 40px;
        height: 40px;
        top: 50%;

        transform: translate(0, -50%);

        z-index: 10;

        font-size: 20px;

        background: #fff;
        border: 1px solid transparent;
        color: #333;

        svg {
            transform: scale(0.5, 0.5) translate(0, -14px);
        }

        &:focus {
            outline: none;
            border: 1px solid #000;
        }

        &.cz__view-arrow-right {
            right: 10px;
        }

        &.cz__view-arrow-left {
            left: 10px;
        }

        span {
            position: absolute;

            left: 15px;
            top: 9px;
        }
    }
</style>

<script>
    import ImageEditor from './ImageEditor';

    export default {
        props: {
            controller: Object,
            view: Object,
        },
        data() {
            return {
                loadingMain: '',
                loadingSplit: '',
                rangeView: null,
                editPlacement: null,
            };
        },
        computed: {
            loading() {
                return (this.loadingMain === 'loading' || this.loadingSplit === 'loading') ? 'loading' : 'done';
            },
        },
        watch: {
            controller: {
                handler() {
                    this.createImage();
                },
                deep: false,
            },

            view() {
                this.selectView();
            },
        },
        mounted() {
            this.createImage();

            window.addEventListener('resize', () => this.resize());
        },
        methods: {
            // Provide a proxy to the API object and listen to important events.
            createImage() {
                // Create a static event listener bound to 'this' pointer.
                if (!this.onImagesLoading) {
                    this.onImagesLoading = (status) => { this.imagesLoading(status); };
                }

                // Clear previous image instance.
                if (this.image) {
                    this.image.off('imagesLoading', this.onImagesLoading);

                    this.image.destroy();
                    this.image = null;
                }

                // Create a new image view.
                if (this.controller) {
                    this.image = new window.DriveCustomizer.ImageView(this.controller, {
                        container: this.$refs.imageview,
                    });

                    this.image.on('imagesLoading', this.onImagesLoading);

                    // Select image view..
                    this.selectView();
                }

                // Split view.

                // Create a static event listener bound to 'this' pointer.
                if (!this.onImagesSplitLoading) {
                    this.onImagesSplitLoading = (status) => { this.imagesSplitLoading(status); };
                }

                // Clear previous image instance.
                if (this.imageSplit) {
                    this.imageSplit.off('imagesLoading', this.onImagesSplitLoading);

                    this.imageSplit.destroy();
                    this.imageSplit = null;
                }

                // Create a new image view.
                if (this.controller) {
                    this.imageSplit = new window.DriveCustomizer.ImageView(this.controller, {
                        container: this.$refs.imagesplitview,
                    });

                    this.imageSplit.on('imagesLoading', this.onImagesSplitLoading);

                    // Select image view..
                    this.selectView();
                }
            },

            // Show image loaders.
            imagesLoading(status) {
                this.loadingMain = status.state;
            },

            // Show image loaders.
            imagesSplitLoading(status) {
                this.loadingSplit = status.state;
            },

            /**
             * Selects the current view.
             */
            selectView() {
                this.editPlacement = this.view && this.view.custom && this.view.custom['editor-placement'];

                // Select new image view.
                [this.image, this.imageSplit].forEach((image) => {
                    if (image && this.view) {
                        // Have the placement edited changed?
                        // If so, repaint the image instead of simply changing to [hopefully] already loaded image.
                        // if editing mode hasn't changed, switch the view.

                        const width = this.view.custom && this.view.custom['editor-base-width'] ? +this.view.custom['editor-base-width'] : null;
                        const height = this.view.custom && this.view.custom['editor-base-height'] ? +this.view.custom['editor-base-height'] : null;

                        image.selectViewByCodeWithOptions(this.view.code, {
                            beforePlacement: image === this.image ? this.editPlacement : null,
                            afterPlacement: image === this.imageSplit ? this.editPlacement : null,
                            baseWidth: width,
                            baseHeight: height,
                        });

                        // If there is a range view, show arrows.
                        const rangeView = image.findRangeView(image.selectedFrame());

                        this.rangeView = rangeView;
                    }
                });
            },

            // Resize image views.
            resize() {
                // Due to body resizing in Customer.vue, we need to resize these views on the next tick.
                this.$nextTick(() => {
                    [this.image, this.imageSplit].forEach((image) => {
                        if (image) {
                            image.resize();
                        }
                    });
                });
            },

            /**
             * Navigates to the previous frame.
             * @returns {void}
             */
            previousFrame() {
                [this.image, this.imageSplit].forEach((image) => {
                    if (image && this.view) {
                        const rangeView = image.findRangeView(image.selectedFrame());

                        if (rangeView) {
                            let frame = image.selectedFrame() - 1;
                            if (frame < rangeView.frameLow) {
                                frame = rangeView.frameHigh;
                            }

                            this.$emit('viewSelected', rangeView);

                            image.updateView(rangeView, frame);
                        }
                    }
                });
            },

            /**
             * Navigates to the next frame.
             * @returns {void}
             */
            nextFrame() {
                [this.image, this.imageSplit].forEach((image) => {
                    if (image && this.view) {
                        const rangeView = image.findRangeView(image.selectedFrame());

                        if (rangeView) {
                            let frame = image.selectedFrame() + 1;
                            if (frame > rangeView.frameHigh) {
                                frame = rangeView.frameLow;
                            }

                            this.$emit('viewSelected', rangeView);

                            image.updateView(rangeView, frame);
                        }
                    }
                });
            },

            /**
             * Spin 360 view.
             */
            beginSpinFrame(type) {
                this.spinDirection = type;

                if (this.spinDirection === 'next') {
                    this.nextFrame();
                } else {
                    this.previousFrame();
                }

                if (this.frameHoldTimer) {
                    clearInterval(this.frameHoldTimer);
                    this.frameHoldTimer = null;
                }

                this.frameHoldTimer = setInterval(() => {
                    if (this.spinDirection === 'next') {
                        this.nextFrame();
                    } else {
                        this.previousFrame();
                    }
                }, 20);
            },

            endSpinFrame() {
                if (this.frameHoldTimer) {
                    clearInterval(this.frameHoldTimer);
                    this.frameHoldTimer = null;
                }
            },
        },
        components: {
            ImageEditor,
        },
    };
</script>